// extracted by mini-css-extract-plugin
export default {"price":"W4-z","priceRow":"X4-z","onSale":"Y4-z","msrpLabelPrice":"Z4-z","msrpLabel":"_4-z","originalPrice":"a5-z","percentOff":"b5-z"};